import React from "react";
import { Phone, Images } from "lucide-react";
import { SERVICES, SERVICE_GALLERY, PHONE_TEL } from "../../lib/site";

export const Services = () => {
  const goToWork = (id) => {
    const cat = SERVICE_GALLERY[id];
    if (cat) window.dispatchEvent(new CustomEvent("select-gallery-category", { detail: cat }));
    const el = document.getElementById("work");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" data-testid="services-section" className="py-20 md:py-28 bg-[#F6F5F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-heading font-bold uppercase tracking-[0.2em] text-[#C8102E] text-sm">
          What We Do
        </p>
        <h2 className="mt-2 font-heading text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-[#0E2A56]">
          Handyman & Home Services
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-slate-700 font-medium">
          From quick home repairs to full remodels and emergency restoration, Journey's
          Handyman is your one-stop local crew across North Georgia and nearby North Carolina.
        </p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                role="button"
                tabIndex={0}
                onClick={() => goToWork(s.id)}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); goToWork(s.id); } }}
                aria-label={`View ${s.title} recent work photos`}
                className={`group bg-white border-2 cursor-pointer ${
                  s.emergency ? "border-[#C8102E]" : "border-[#0E2A56]"
                } overflow-hidden hover:-translate-y-1 transition-transform duration-150`}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={s.image}
                    alt={`${s.title} in Blairsville and North Georgia`}
                    className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  {s.emergency && (
                    <span className="absolute top-3 left-3 bg-[#C8102E] text-white font-heading font-bold uppercase text-xs tracking-widest px-3 py-1">
                      24/7 Same Day
                    </span>
                  )}
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3">
                    <span className={`inline-flex h-11 w-11 items-center justify-center ${
                      s.emergency ? "bg-[#C8102E]" : "bg-[#0E2A56]"
                    } text-white`}>
                      <Icon className="h-6 w-6" strokeWidth={2.5} />
                    </span>
                    <h3 className="font-heading text-2xl font-bold uppercase tracking-tight text-[#0E2A56] leading-none">
                      {s.title}
                    </h3>
                  </div>
                  <p className="mt-4 text-slate-700 leading-relaxed">{s.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-2 font-heading font-bold uppercase tracking-wide text-sm text-[#C8102E] group-hover:gap-3 transition-all">
                    <Images className="h-4 w-4" strokeWidth={2.5} /> See recent work →
                  </span>
                </div>
              </div>
            );
          })}

          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="services-cta-card"
            className="bg-[#0E2A56] text-white p-8 flex flex-col justify-center border-2 border-[#0E2A56] hover:bg-[#0A1E3F] transition-colors"
          >
            <h3 className="font-heading text-3xl font-extrabold uppercase tracking-tight leading-none">
              Need something else fixed?
            </h3>
            <p className="mt-3 text-white/80">
              If it's around the house, chances are we handle it. Call now and just ask.
            </p>
            <span className="mt-6 inline-flex items-center gap-2 font-heading font-bold uppercase tracking-wide text-[#C8102E] group">
              <Phone className="h-5 w-5" strokeWidth={2.5} /> Call for a free quote
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};
